<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="contents">
<h2 class="contentsHead"><span class="bold">CONTENTS</span></h2>
<div class="contentsEntry" id="contentsEntry0">
<p class="contentsEntryName"><a href="#/9781416995050_ch01#ch01"><span class="bold">CHAPTER 1</span></a></p></div>
<div class="contentsEntry" id="contentsEntry1">
<p class="contentsEntryName"><a href="#/9781416995050_ch02#ch02"><span class="bold">CHAPTER 2</span></a></p></div>
<div class="contentsEntry" id="contentsEntry2">
<p class="contentsEntryName"><a href="#/9781416995050_ch03#ch03"><span class="bold">CHAPTER 3</span></a></p></div>
<div class="contentsEntry" id="contentsEntry3">
<p class="contentsEntryName"><span href="#/9781416995050_ch04#ch04" title="Link target outside of Sample"><span class="bold">CHAPTER 4</span></span></p></div>
<div class="contentsEntry" id="contentsEntry4">
<p class="contentsEntryName"><span href="#/9781416995050_ch05#ch05" title="Link target outside of Sample"><span class="bold">CHAPTER 5</span></span></p></div>
<div class="contentsEntry" id="contentsEntry5">
<p class="contentsEntryName"><span href="#/9781416995050_ch06#ch06" title="Link target outside of Sample"><span class="bold">CHAPTER 6</span></span></p></div>
<div class="contentsEntry" id="contentsEntry6">
<p class="contentsEntryName"><span href="#/9781416995050_ch07#ch07" title="Link target outside of Sample"><span class="bold">CHAPTER 7</span></span></p></div>
<div class="contentsEntry" id="contentsEntry7">
<p class="contentsEntryName"><span href="#/9781416995050_ch08#ch08" title="Link target outside of Sample"><span class="bold">CHAPTER 8</span></span></p></div>
<div class="contentsEntry" id="contentsEntry8">
<p class="contentsEntryName"><span href="#/9781416995050_ch09#ch09" title="Link target outside of Sample"><span class="bold">CHAPTER 9</span></span></p></div>
<div class="contentsEntry" id="contentsEntry9">
<p class="contentsEntryName"><span href="#/9781416995050_ch10#ch10" title="Link target outside of Sample"><span class="bold">CHAPTER 10</span></span></p></div>
<div class="contentsEntry" id="contentsEntry10">
<p class="contentsEntryName"><span href="#/9781416995050_ch11#ch11" title="Link target outside of Sample"><span class="bold">CHAPTER 11</span></span></p></div>
<div class="contentsEntry" id="contentsEntry11">
<p class="contentsEntryName"><span href="#/9781416995050_ch12#ch12" title="Link target outside of Sample"><span class="bold">CHAPTER 12</span></span></p></div>
<div class="contentsEntry" id="contentsEntry12">
<p class="contentsEntryName"><span href="#/9781416995050_ch13#ch13" title="Link target outside of Sample"><span class="bold">CHAPTER 13</span></span></p></div>
<div class="contentsEntry" id="contentsEntry13">
<p class="contentsEntryName"><span href="#/9781416995050_ch14#ch14" title="Link target outside of Sample"><span class="bold">CHAPTER 14</span></span></p></div>
<div class="contentsEntry" id="contentsEntry14">
<p class="contentsEntryName"><span href="#/9781416995050_ch15#ch15" title="Link target outside of Sample"><span class="bold">CHAPTER 15</span></span></p></div>
<div class="contentsEntry" id="contentsEntry15">
<p class="contentsEntryName"><span href="#/9781416995050_ch16#ch16" title="Link target outside of Sample"><span class="bold">CHAPTER 16</span></span></p></div>
<div class="contentsEntry" id="contentsEntry16">
<p class="contentsEntryName"><span href="#/9781416995050_ch17#ch17" title="Link target outside of Sample"><span class="bold">CHAPTER 17</span></span></p></div>
<div class="contentsEntry" id="contentsEntry17">
<p class="contentsEntryName"><span href="#/9781416995050_ch18#ch18" title="Link target outside of Sample"><span class="bold">CHAPTER 18</span></span></p></div>
<div class="contentsEntry" id="contentsEntry18">
<p class="contentsEntryName"><span href="#/9781416995050_ch19#ch19" title="Link target outside of Sample"><span class="bold">CHAPTER 19</span></span></p></div>
<div class="contentsEntry" id="contentsEntry19">
<p class="contentsEntryName"><span href="#/9781416995050_ch20#ch20" title="Link target outside of Sample"><span class="bold">CHAPTER 20</span></span></p></div>
<div class="contentsEntry" id="contentsEntry20">
<p class="contentsEntryName"><span href="#/9781416995050_ch21#ch21" title="Link target outside of Sample"><span class="bold">CHAPTER 21</span></span></p></div>
<div class="contentsEntry" id="contentsEntry21">
<p class="contentsEntryName"><span href="#/9781416995050_ch22#ch22" title="Link target outside of Sample"><span class="bold">CHAPTER 22</span></span></p></div>
<div class="contentsEntry" id="contentsEntry22">
<p class="contentsEntryName"><span href="#/9781416995050_ch23#ch23" title="Link target outside of Sample"><span class="bold">CHAPTER 23</span></span></p></div>
<div class="contentsEntry" id="contentsEntry23">
<p class="contentsEntryName"><span href="#/9781416995050_ch24#ch24" title="Link target outside of Sample"><span class="bold">CHAPTER 24</span></span></p></div>
<div class="contentsEntry" id="contentsEntry24">
<p class="contentsEntryName"><span href="#/9781416995050_ch25#ch25" title="Link target outside of Sample"><span class="bold">CHAPTER 25</span></span></p></div>
<div class="contentsEntry" id="contentsEntry25">
<p class="contentsEntryName"><span href="#/9781416995050_ch26#ch26" title="Link target outside of Sample"><span class="bold">CHAPTER 26</span></span></p></div>
<div class="contentsEntry" id="contentsEntry26">
<p class="contentsEntryName"><span href="#/9781416995050_ch27#ch27" title="Link target outside of Sample"><span class="bold">CHAPTER 27</span></span></p></div>
<div class="contentsEntry" id="contentsEntry27">
<p class="contentsEntryName"><span href="#/9781416995050_ch28#ch28" title="Link target outside of Sample"><span class="bold">CHAPTER 28</span></span></p></div>
<div class="contentsEntry" id="contentsEntry28">
<p class="contentsEntryName"><span href="#/9781416995050_ack01#ack01" title="Link target outside of Sample"><span class="bold">ACKNOWLEDGMENTS</span></span></p></div>
<div class="contentsEntry" id="contentsEntry29">
<p class="contentsEntryName"><span href="#/9781416995050_ata01#ata01" title="Link target outside of Sample"><span class="bold">ABOUT THE AUTHOR</span></span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416995050_contents.vue?2bed528d